module.exports = __webpack_public_path__ + "static/media/erik-odiin-V6OwHJpilAE-unsplash.de19e2c6.jpg";